/**
 * Enumeration of possible date validation error types.
 * Apps map these to their own localized error messages.
 */
export enum DateValidationErrorType {
  REQUIRED = "REQUIRED",
  INVALID_FORMAT = "INVALID_FORMAT",
  INVALID_DATE = "INVALID_DATE",
  FUTURE_DATE = "FUTURE_DATE",
  PAST_DATE = "PAST_DATE",
}

/**
 * Result of date validation.
 * Contains validation status and error type for mapping to app-specific messages.
 */
export interface DateValidationResult {
  isValid: boolean;
  errorType: DateValidationErrorType | null;
}

/**
 * Configuration options for date validation.
 */
export interface DateValidationOptions {
  /** Whether an empty value should be treated as an error. Default: true */
  required?: boolean;
  /** Minimum allowed date. Default: 1900-01-01 */
  minDate?: Date;
  /** Maximum allowed date. Default: today */
  maxDate?: Date;
}
